import clsx from "clsx";
import { unstable__Button as Button } from "@hagerty/react-components";
import { mt } from "../../../utils/tracking";
import { ActionProps } from "./Action.props";
import styles from "./Action.module.scss";

export const Action = ({
  className,
  actionConfig,
  actionStyle,
}: ActionProps) => {
  if (!actionConfig) return null;

  const { ariaLabel, text, tagAction } = actionConfig;

  const href = "href" in actionConfig ? actionConfig.href : undefined;
  const onClick = () => {
    if (tagAction) {
      mt.trackAction(tagAction);
    }

    if (actionConfig.onClick) {
      actionConfig.onClick();
    }
  };

  if (actionStyle == "link") {
    return (
      <Button
        aria-label={ariaLabel}
        variant="text"
        size="medium"
        color="blueberry"
        className={clsx(className, styles.link)}
        onClick={onClick}
        href={href}
      >
        {text}
      </Button>
    );
  }

  return (
    <Button
      aria-label={ariaLabel}
      variant="solid"
      size="small"
      className={clsx(className, styles.button)}
      href={href}
      onClick={onClick}
    >
      {text}
    </Button>
  );
};
